export default defineNuxtRouteMiddleware(async () => {
  try { await useAuthSession().ensure() } catch { /* A network failure is not a logout. */ }
})
